import { useQuery, useQueryClient } from '@tanstack/vue-query'

interface UserCorporateMember {
  privilegeValue: string // 权益值（截止日期的时间戳
  privilegeValueInDays: string // 剩余天数
  totalUserRelationCount: string // 子账号总数
  usedUserRelationCount: string // 已使用子账号总数
}

interface OrderType {
  id: string
  tradeNumber: string
  totalAmount: number
  status: 0 | 1 | 2 | 3 | 4
  paymentInfo: string
  tradeInfo: string
  createTime: string
}
export function usePay() {
  const { $request } = useNuxtApp()
  const account = ref(1)
  const { data: userCorporateMember, refetch: fetchCorporateMember } = useQuery({
    queryKey: ['/member/userCorporateMember'],
    queryFn: ({ signal }) => {
      return $request<UserCorporateMember>('/member/userCorporateMember', { signal })
    },
  })
  const user = useUser()
  const userRole = computed(() => user.value.info?.privilegesV2?.find((item: any) => item.resource === user.value.info?.userRole))
  const accountPrivileage = computed(() => {
    return user.value.privileges?.find(item => item.resource === 6)?.privileges[0]
  })
  const curItem = ref()
  const totalAcount = computed(() => {
    let _account = 0
    if (curItem.value?.resource === 1) {
      _account = user.value.info?.userRole === 3
        ? account.value
        : user.value.info?.userRole === 2
          ? userCorporateMember.value?.usedUserRelationCount
          : userCorporateMember.value?.totalUserRelationCount
    }
    return Math.max(_account, 0)
  })

  const curPrivilege = ref()

  const params = computed(() => {
    let accountText = ''
    if (totalAcount.value) {
      accountText = `,${accountPrivileage.value?.privilegeId}x${totalAcount.value}`
    }
    const _account = curPrivilege.value?.resource === 6 ? account.value : 1
    return !curPrivilege.value
      ? null
      : {
          privileges: `${curPrivilege.value?.privilegeId}x${_account}${accountText}`,
          payType: 1,
        }
  })
  const isPolling = ref(false)
  const { data: orderInfo, isFetching: loading, refetch: fetchTrades } = useQuery({
    queryKey: ['/trades'],
    queryFn: async ({ signal }) => {
      cancelQueryIsPay()
      if (!params.value)
        return
      const res = await $request<OrderType>(
        `/trades`,
        {
          body: params.value,
          method: 'POST',
          signal,
        },
      )
      return res
    },
    enabled: false,
  })
  const { data: tradeInfo } = useQuery({
    queryKey: [`/trades/${orderInfo.value?.tradeNumber}`, isPolling.value],
    queryFn: ({ signal }) => {
      if (!orderInfo.value?.tradeNumber) {
        return
      }
      return $request<OrderType>(
        `/trades/${orderInfo.value?.tradeNumber}`,
        {
          signal,
        },
      )
    },
    enabled: () => !!orderInfo.value?.tradeNumber && isPolling.value,
    refetchInterval: 1000, // 每隔 1秒轮询一次
    refetchOnWindowFocus: false,
  })
  // 清除轮询
  function cancelQueryIsPay() {
    isPolling.value = false
  }
  watch(() => orderInfo.value, (newOrderInfo) => {
    if (newOrderInfo?.tradeNumber) {
      isPolling.value = true
    }
  })
  onBeforeUnmount(() => {
    cancelQueryIsPay()
  })
  const popoverVisible = ref(false)
  return {
    account,
    tradeInfo,
    totalAcount,
    curPrivilege,
    curItem,
    userRole,
    orderInfo,
    loading,
    accountPrivileage,
    userCorporateMember,
    fetchTrades,
    cancelQueryIsPay,
    fetchCorporateMember,
    popoverVisible,
  }
}
